<template>
  <div class="AsideIcon" @click="upAside">
    <i class="AsideIcon-icon el-icon-s-operation"></i>
  </div>
</template>

<script>
export default {
  methods:{
    upAside(){
      
      let clientWidth = document.documentElement.clientWidth || document.body.clientWidth
      clientWidth < 700 ? this.$emit('changedrawer') : this.$store.commit('upAside')
    }
  }
};
</script>

<style lang="scss">
.AsideIcon > .AsideIcon-icon {
  font-size: 22px;
  padding: 10px;
}
</style>